import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { myPagePath } from '../utils/myPage';
import { Button } from "@/components/ui/button";

const LandingNav = ({ onLogin, onSignUp, onJoinWaitlist, isLoggedIn }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavAction = (action) => {
    setMenuOpen(false);
    action();
  };

  return (
    <>
      <div
        className="fixed top-0 left-0 right-0 z-50"
        style={{ backgroundColor: '#EEE7D8' }}
      >
        <div
          className="flex justify-between items-center px-4 md:px-8 py-4 md:py-6"
          style={{ maxWidth: '1400px', margin: '0 auto' }}
        >
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_393ec875-54a1-44b5-aa19-8314f136e991/artifacts/5dh5037r_wellby-beta-logo.png"
              alt="Wellby Beta"
              className="cursor-pointer"
              onClick={() => navigate('/')}
              style={{ height: '50px', width: 'auto' }}
            />
          </div>

          <div className="hidden md:flex items-center" style={{ gap: '16px' }}>
            <button
              onClick={() => navigate('/pricing')}
              className="font-medium text-sm md:text-base hover:opacity-70 transition-opacity"
              style={{
                color: '#51120A',
                fontFamily: "'Bricolage Grotesque', sans-serif",
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '8px 4px'
              }}
            >
              Pricing
            </button>
            {isLoggedIn ? (
              <Button
                onClick={() => navigate(myPagePath())}
                className="px-4 py-2 md:px-6 md:py-3 text-white font-medium text-sm md:text-base transition-colors"
                style={{
                  backgroundColor: '#51120A',
                  fontFamily: "'Bricolage Grotesque', sans-serif"
                }}
              >
                My Recipes
              </Button>
            ) : (
              <>
                <button
                  onClick={onLogin}
                  className="font-medium text-sm md:text-base hover:opacity-70 transition-opacity"
                  style={{
                    color: '#51120A',
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '8px 4px'
                  }}
                >
                  Login
                </button>
                <Button
                  onClick={onSignUp}
                  variant="outline"
                  className="px-4 py-2 md:px-6 md:py-3 font-medium text-sm md:text-base hover-blush transition-colors focus:outline-none focus:ring-0"
                  style={{
                    borderColor: '#51120A',
                    color: '#51120A',
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    borderWidth: '1px'
                  }}
                >
                  Sign Up
                </Button>
                <Button
                  onClick={onJoinWaitlist}
                  className="px-4 py-2 md:px-6 md:py-3 text-white font-medium text-sm md:text-base join-waitlist-btn transition-colors"
                  style={{
                    backgroundColor: '#51120A',
                    borderColor: '#51120A',
                    fontFamily: "'Bricolage Grotesque', sans-serif"
                  }}
                >
                  Join Waitlist
                </Button>
              </>
            )}
          </div>

          <div className="flex md:hidden items-center" style={{ gap: '12px' }}>
            {isLoggedIn ? (
              <Button
                onClick={() => navigate(myPagePath())}
                className="px-4 py-2 text-white font-medium text-sm transition-colors"
                style={{
                  backgroundColor: '#51120A',
                  fontFamily: "'Bricolage Grotesque', sans-serif"
                }}
              >
                My Recipes
              </Button>
            ) : (
              <Button
                onClick={() => handleNavAction(onJoinWaitlist)}
                className="px-4 py-2 text-white font-medium text-sm join-waitlist-btn transition-colors"
                style={{
                  backgroundColor: '#51120A',
                  borderColor: '#51120A',
                  fontFamily: "'Bricolage Grotesque', sans-serif"
                }}
              >
                Join Waitlist
              </Button>
            )}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
              aria-controls="mobile-nav-menu"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                position: 'relative',
                width: '32px',
                height: '32px'
              }}
            >
              <span style={{
                display: 'block',
                width: '22px',
                height: '2px',
                backgroundColor: '#51120A',
                borderRadius: '1px',
                position: 'absolute',
                left: '5px',
                transition: 'transform 0.3s, opacity 0.3s, top 0.3s',
                top: menuOpen ? '15px' : '8px',
                transform: menuOpen ? 'rotate(45deg)' : 'none'
              }} />
              <span style={{
                display: 'block',
                width: '22px',
                height: '2px',
                backgroundColor: '#51120A',
                borderRadius: '1px',
                position: 'absolute',
                left: '5px',
                top: '15px',
                transition: 'opacity 0.3s',
                opacity: menuOpen ? 0 : 1
              }} />
              <span style={{
                display: 'block',
                width: '22px',
                height: '2px',
                backgroundColor: '#51120A',
                borderRadius: '1px',
                position: 'absolute',
                left: '5px',
                transition: 'transform 0.3s, opacity 0.3s, top 0.3s',
                top: menuOpen ? '15px' : '22px',
                transform: menuOpen ? 'rotate(-45deg)' : 'none'
              }} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div
          id="mobile-nav-menu"
          className="fixed inset-0 z-40 md:hidden"
          style={{
            backgroundColor: '#EEE7D8',
            paddingTop: '90px',
            paddingLeft: '24px',
            paddingRight: '24px'
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <button
              onClick={() => handleNavAction(() => navigate('/pricing'))}
              style={{
                fontFamily: "'Bricolage Grotesque', sans-serif",
                fontSize: '18px',
                fontWeight: '500',
                color: '#51120A',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                padding: '12px 0',
                borderBottom: '1px solid #51120A20'
              }}
            >
              Pricing
            </button>
            {isLoggedIn ? (
              <button
                onClick={() => handleNavAction(() => navigate(myPagePath()))}
                style={{
                  fontFamily: "'Bricolage Grotesque', sans-serif",
                  fontSize: '18px',
                  fontWeight: '500',
                  color: '#51120A',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left',
                  padding: '12px 0',
                  borderBottom: '1px solid #51120A20'
                }}
              >
                My Recipes
              </button>
            ) : (
              <>
                <button
                  onClick={() => handleNavAction(onSignUp)}
                  style={{
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    fontSize: '18px',
                    fontWeight: '500',
                    color: '#51120A',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                    padding: '12px 0',
                    borderBottom: '1px solid #51120A20'
                  }}
                >
                  Sign Up
                </button>
                <button
                  onClick={() => handleNavAction(onLogin)}
                  style={{
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    fontSize: '18px',
                    fontWeight: '500',
                    color: '#51120A',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                    padding: '12px 0',
                    borderBottom: '1px solid #51120A20'
                  }}
                >
                  Login
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default LandingNav;
